import { FileSpreadsheet, FileText, Presentation, type LucideIcon } from 'lucide-react';
import { Badge } from '@bliks-io/ui';
import type { PartnerMaterialFileFormat } from '@bliks-io/contracts';

const FORMAT_ICONS: Record<PartnerMaterialFileFormat, LucideIcon> = {
  pdf: FileText,
  docx: FileText,
  pptx: Presentation,
  xlsx: FileSpreadsheet
};

export function PartnerFileFormatIcon({
  format
}: {
  format: PartnerMaterialFileFormat | undefined;
}) {
  const Icon = format ? FORMAT_ICONS[format] : FileText;
  return <Icon className="h-5 w-5 shrink-0 text-muted-foreground" />;
}

/** The format as a short tag; partners look for the purpose, the format is a detail. */
export function PartnerFileFormatBadge({ format }: { format: PartnerMaterialFileFormat }) {
  return (
    <Badge variant="outline" shape="rounded" size="sm">
      {format.toUpperCase()}
    </Badge>
  );
}
